const React = require("react");

function InformationCircleIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, props), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
  }));
}

module.exports = InformationCircleIcon;


/*****************
 ** WEBPACK FOOTER
 ** ./~/@heroicons/react/outline/InformationCircleIcon.js
 ** module id = 547
 ** module chunks = 0
 **/